import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=b8fe8ecc&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"
import style0 from "./Button.scss?vue&type=style&index=0&id=b8fe8ecc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fe8ecc",
  null
  
)

export default component.exports